import config from '../../config';

const { accountBaseUrl = '' } = config() || {};

export const skipLinks = [
  {
    name: 'Skip to main content',
    url: '#main',
  },
  {
    name: 'Skip to footer',
    url: '#footer',
  },
];

export const topLinks = [
  {
    name: 'About us',
    url: '/customer-services/about-us',
  },
  {
    name: 'John Lewis Brands',
    url: '/content/discover-john-lewis-brands',
  },
  {
    name: 'Our shops',
    url: '/our-shops',
  },
  {
    name: 'Customer services',
    url: '/customer-services',
  },
  {
    name: 'Our services',
    url: '/our-services',
  },
  {
    name: 'Track order',
    url: `${accountBaseUrl}/track-order`,
  },
  {
    name: 'My John Lewis',
    url: '/our-services/my-john-lewis',
  },
  {
    name: 'Partnership Card',
    url: 'https://www.johnlewisfinance.com/partnership-card.html?track=XC50',
    external: true,
  },
  {
    name: 'Insurance',
    url: 'https://www.johnlewisfinance.com/insurance.html?track=JLj0008',
    external: true,
  },
];

export const topLinksWithBrands = [
  ...topLinks.slice(0, 3),
  {
    handler: () => {
      document.body.dispatchEvent(
        new CustomEvent('dataStateChange', {
          detail: {
            action: 'jl.toplink.brands',
            navigation: '/brands',
          },
        })
      );
    },
    name: 'Brands',
    url: '/brands',
  },
  ...topLinks.slice(3),
];

export const getAccountLinks = baseUrl => [
  {
    name: 'My account',
    url: '/my-account',
  },
  {
    name: 'My John Lewis rewards',
    url: `${baseUrl || ''}/rewards`,
  },
  {
    name: 'Wish list',
    url: `${baseUrl || ''}/wish-list`,
  },
  {
    name: 'Appointments',
    url: '/appointments/manage',
  },
  {
    name: 'Sign out',
    url: '/sign-out',
  },
];

export const getMobileLinks = baseUrl => [
  {
    name: 'My Account',
    url: '/my-account',
    isDisplayedInGlobalNav: false,
    child: [
      {
        name: 'Sign in',
        url: '/sign-in',
        isDisplayedInGlobalNav: false,
        accountHeaderOnly: true,
      },
      {
        name: 'Track Order',
        url: `${baseUrl || ''}/track-order`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'My John Lewis rewards',
        url: `${baseUrl || ''}/rewards`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Wish List',
        url: `${baseUrl || ''}/wish-list`,
        isDisplayedInGlobalNav: false,
      },
    ],
    authenticatedItems: [
      {
        name: 'View my account',
        url: '/my-account',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Track my order',
        url: `${baseUrl || ''}/track-order`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'My John Lewis rewards',
        url: `${baseUrl || ''}/rewards`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Wish List',
        url: `${baseUrl || ''}/wish-list`,
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Sign out',
        url: 'https://www.johnlewis.com/sign-out',
        isDisplayedInGlobalNav: false,
        accountHeaderOnly: true,
      },
    ],
  },
  {
    name: 'Help',
    url: '/customer-services',
    isDisplayedInGlobalNav: false,
    child: [
      {
        name: 'Customer services',
        url: '/customer-services',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Delivery & collection',
        url: '/customer-services/delivery-information',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Returns & refunds',
        url: '/customer-services/returns',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'Shop finder',
        url: '/our-shops',
        isDisplayedInGlobalNav: false,
      },
    ],
  },
  {
    name: 'Services and experiences',
    url: '/our-services',
    isDisplayedInGlobalNav: false,
    child: [
      {
        name: 'Our services',
        url: '/our-services',
        isDisplayedInGlobalNav: false,
      },
      {
        name: 'More from us',
        url: '/our-services/more-from-john-lewis',
        isDisplayedInGlobalNav: false,
      },
    ],
  },
];

const FEEDBACK_LINK =
  'https://edigitalsurvey.com/survey/enter/s/ESV-136225211/data2/mobile/collection_url/';

export const feedbackLink = {
  name: 'Feedback',
  text: 'Your comments help us improve our website',
  button: { label: 'Leave Feedback', url: FEEDBACK_LINK },
  feedback: true,
};

export const getStaticMobileMenus = (baseUrl, signedIn) => [
  ...getMobileLinks(baseUrl).map(menu => ({
    ...menu,
    child:
      signedIn && menu.authenticatedItems
        ? menu.authenticatedItems
        : menu.child,
    authenticatedItems: undefined,
  })),
  feedbackLink,
];
